<template> <!-- 备注 -->
  <div>
    <el-button
      size="small" style="margin-right: 10px;"
      @click="open"
    >{{ $t('receivablePayable.remark') }}</el-button>

    <el-dialog
      :append-to-body="true"
      :title="$t('receivablePayable.AddANote')"
      :visible.sync="isBool"
      width="500px"
      :loading="loading"
    >
      <el-form
        ref="ruleForm" :model="ruleForm" :rules="rules"
        label-width="10px" class="demo-ruleForm"
      >
        <el-form-item label="" prop="remarks">
          <el-input
            v-model="ruleForm.remarks"
            type="textarea"
            :placeholder="$t('GlobalSetObj.pleaseInput')"
            :autosize="{ minRows: 5, maxRows: 10}"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <!--取 消-->
        <el-button @click="isBool = false">{{ $t('basicData.Cancel') }}</el-button>

        <!--确 定-->
        <el-button type="primary" @click="submitForm('ruleForm')">{{ $t('basicData.determine') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: '',

  props: {
    // 提交函数
    asyncSubmit: {
      type: Function,
      required: true
    }
  },

  data() {
    return {
      isBool: false,
      ruleForm: {
        remarks: ''
      },
      loading: false,

      rules: {
        remarks: [
          { required: true, message: this.$t('GlobalSetObj.pleaseInput'), trigger: 'blur' }
        ]
      }
    };
  },

  activated() {
    // this.getPermission();
  },
  created() {
    // this.getPermission();
  },

  methods: {
    open() {
      this.isBool = true;
      this.ruleForm.remarks = '';
    },
    // 提交
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) {
          return false;
        }

        this.onDetermine();
      });
    },

    // 确定
    onDetermine() {
      this.loading = true;
      this.asyncSubmit(this.ruleForm.remarks).then(() => {
        this.isBool = false;
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
